import * as React from "react";
import { Statistic, Label } from "semantic-ui-react";

interface Props {
    label: string;
    value: number;
}

export const StatisticBadgeOld = (props: Props) => (
    <Statistic className="statistic">
        <Statistic.Label><Label content={props.label} /></Statistic.Label>
        <Statistic.Value>{props.value}</Statistic.Value>
    </Statistic>
);
